export const READ_CARD = 'READ_CARD';
export const CANCEL_READ_CARD = 'CANCEL_READ_CARD'